<template>
  <div id="token" class="container" style="height: 87%;">
    <div v-if="loading" class="mt-3 text-center">
      <h5>Veuillez patienter...</h5>
    </div>
  </div>
</template>

<script>
import AuthService from '../../services/auth.service';

export default {
  name: 'Callback',

  props: {
    code: {
      type: String,
    },

    state: {
      type: String,
    }
  },

  data() {
    return {
      loading: false,
    };
  },

  mounted() {
    this.identification();
  },

  methods: {
    identification() {
      this.loading = true;
      AuthService.identification(this.code, this.state).then(() => {
        this.loading = false;
        this.$router.push({
          name: 'Auth',
        });
      }).catch(error => {
        if (error.response.status === 404) {
          window.location.href = error.response.data.url;
        }
        if (error.response.status === 403 || error.response.status === 401) {
          this.$router.push({ name: '403' });
        }
      });
    }
  },
};
</script>
